import React from 'react';
import { Link } from 'react-router-dom';
import './SideNav.css';

const SideNav = ({ isOpen, toggleNav, onCall, calls }) => {
  return (
    <div className={`sidenav ${isOpen ? 'open' : ''}`}>
      <button className="closebtn" onClick={toggleNav}>&times;</button>
      <Link to="/"><button>Home</button></Link>
      <button onClick={() => onCall(calls[0])}>High Priority Call</button>
      <button onClick={() => onCall(calls[1])}>Medium Priority Call</button>
      <button onClick={() => onCall(calls[2])}>Low Priority Call</button>
      <Link to="/resource-orchestration"><button>Admin View</button></Link>
      <Link to="/freight-masters"><button>Freight Masters</button></Link>
      <button>About</button>
      <button>Services</button>
      <button>Clients</button>
      <button>Contact</button>
    </div>
  );
};

export default SideNav;